function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "segments/desktop/core-components/button/button";
import Check from "monday-ui-react-core/dist/icons/Check";
import colors from "styles/colors";
const ProductCardGridBodyComponent = (props)=>{
    var _useCases_list;
    const { body, showDivider, dividerStyle, useCases, theme, productCardButtonConfig } = props;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "product-card-body",
                children: body === null || body === void 0 ? void 0 : body.bodyText
            }),
            showDivider && /*#__PURE__*/ _jsx("div", {
                className: "product-card-divider",
                style: dividerStyle
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "product-card-use-cases",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "product-card-use-cases-title",
                        children: useCases === null || useCases === void 0 ? void 0 : useCases.text
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "product-card-use-cases-bullets",
                        children: useCases === null || useCases === void 0 ? void 0 : (_useCases_list = useCases.list) === null || _useCases_list === void 0 ? void 0 : _useCases_list.map((useCase, index)=>/*#__PURE__*/ _jsxs("div", {
                                className: "product-card-use-cases-bullet-icon-and-text",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "product-card-use-cases-bullet-icon",
                                        style: {
                                            color: colors[theme]
                                        },
                                        children: /*#__PURE__*/ _jsx(Check, {})
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "product-card-use-cases-bullet-text",
                                        children: useCase === null || useCase === void 0 ? void 0 : useCase.text
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "product-card-footer",
                children: /*#__PURE__*/ _jsx(Button, _object_spread({}, productCardButtonConfig))
            })
        ]
    });
};
export default ProductCardGridBodyComponent;
